// import axios from 'axios';
import React, { useContext, useEffect, useReducer } from 'react';
import GlobalReducer from '../reducers/GlobalReducer';
import { baseServerUrl } from '../utils/constants';
import DynamicSort from '../functions/DynamicSort';
import axios from 'axios';
import {
  GET_ACTIVITIES_BEGIN,
  GET_ACTIVITIES_SUCCESS,
  GET_ACTIVITIES_ERROR,
  DISPLAY_ALERT,
  CLEAR_ALERT,
  SETUP_USER_BEGIN,
  SETUP_USER_SUCCESS,
  SETUP_USER_ERROR,
  TOGGLE_SIDEBAR,
  LOGOUT_USER,
  UPDATE_USER_BEGIN,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  HANDLE_CHANGE,
  CLEAR_VALUES,
  CREATE_LESSON_BEGIN,
  CREATE_LESSON_SUCCESS,
  CREATE_LESSON_ERROR,
  GET_LESSONS_BEGIN,
  GET_LESSONS_SUCCESS,
  SET_EDIT_LESSON,
  DELETE_LESSON_BEGIN,
  DELETE_LESSON_ERROR,
  EDIT_LESSON_BEGIN,
  EDIT_LESSON_SUCCESS,
  EDIT_LESSON_ERROR,
  CLEAR_FILTERS,
  CHANGE_PAGE,
  GET_CURRENT_USER_BEGIN,
  GET_CURRENT_USER_SUCCESS,
} from '../utils/actions';
import { dummylessons, dummyusers } from '../utils/dummydata';

const initialState = {
  activities: [],
  activities_loading: false,
  activities_error: false,
  totalActivities: 0,
  userLoading: true,
  isLoading: false,
  showAlert: false,
  alertText: '',
  alertType: '',
  user: null,
  userAddress1: '',
  userAddress2: '',
  userPhone: '',
  isAdmin: false,
  isMember: false,
  isLoggedIn: false,
  showSidebar: false,
  isEditing: false,
  lessons: [],
  editLessonId: '',
  day: '',
  date: '',
  duration: '',
  age: '',
  lessonLocationName: '',
  lessonLocationAddress: '',
  lessonTypeOptions: ['FitKlas', 'Family Acro Yoga', 'CrossFit 4 Kids'],
  lessonType: 'Family Acro Yoga',
  showLesson: false,
  lessons_loading: false,
  lessons_error: false,
  totalLessons: 0,
  numOfPages: 1,
  page: 1,
  search: '',
  searchStatus: 'all',
  searchType: 'all',
  sort: 'latest',
  sortOptions: ['latest', 'oldest', 'a-z', 'z-a'],
};

const GlobalContext = React.createContext();

export const ContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(GlobalReducer, initialState);

  //axios
  const authFetch = axios.create({ baseURL: baseServerUrl });

  // response
  authFetch.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        logoutUser();
      }
      return Promise.reject(error);
    }
  );

  /*
   * Activities
   */
  const getActivities = async () => {
    let url = baseServerUrl.concat('/activiteiten');
    dispatch({ type: GET_ACTIVITIES_BEGIN });
    try {
      const response = await fetch(url);
      const activities = await response.json();
      activities.sort(DynamicSort('date'));
      console.log(activities[0].description);
      dispatch({ type: GET_ACTIVITIES_SUCCESS, payload: { activities } });
    } catch (error) {
      dispatch({ type: GET_ACTIVITIES_ERROR });
      logoutUser();
    }
  };

  const displayAlert = () => {
    dispatch({ type: DISPLAY_ALERT });
    clearAlert();
  };

  const clearAlert = () => {
    // setTimeout(() => {
    //   dispatch({ type: CLEAR_ALERT });
    // }, 3000);
  };

  const setupUser = async ({ currentUser, endPoint, alertText }) => {
    dispatch({ type: SETUP_USER_BEGIN });
    try {
      // const { data } = await axios.post(
      //   `/api/v1/auth/${endPoint}`,
      //   currentUser
      // );
      // const { user } = data;
      // dummy data test
      const user = dummyusers.filter((user) => {
        return user.email === currentUser.email;
      });

      dispatch({
        type: SETUP_USER_SUCCESS,
        payload: { user, alertText },
      });
      // console.log(state.userLoading);
    } catch (error) {
      dispatch({
        type: SETUP_USER_ERROR,
        payload: { msg: error.response.data.msg },
      });
    }
    clearAlert();
  };

  const toggleSidebar = () => {
    dispatch({ type: TOGGLE_SIDEBAR });
  };

  const logoutUser = async () => {
    // await authFetch.get('/auth/logout');

    dispatch({ type: LOGOUT_USER });
  };

  const updateUser = async (currentUser) => {
    dispatch({ type: UPDATE_USER_BEGIN });
    try {
      // const { data } = await authFetch.patch('/auth/updateUser', currentUser);
      // const { user } = data;

      const { user } = dummyusers.filter(
        (user) => user.email === currentUser.email
      );

      dispatch({
        type: UPDATE_USER_SUCCESS,
        payload: { user },
      });
    } catch (error) {
      if (error.response.status !== 401) {
        dispatch({
          type: UPDATE_USER_ERROR,
          payload: { msg: error.response.data.msg },
        });
      }
    }
    clearAlert();
  };

  const handleChange = ({ name, value }) => {
    dispatch({ type: HANDLE_CHANGE, payload: { name, value } });
  };
  const clearValues = () => {
    dispatch({ type: CLEAR_VALUES });
  };

  const createLesson = async () => {
    dispatch({ type: CREATE_LESSON_BEGIN });
    try {
      const {
        day,
        date,
        duration,
        age,
        lessonLocationName,
        lessonLocationAddress,
        lessonType,
        showLesson,
      } = state;
      await authFetch.post('/lessen', {
        day,
        date,
        duration,
        age,
        lessonLocationName,
        lessonLocationAddress,
        lessonType,
        showLesson,
      });
      dispatch({ type: CREATE_LESSON_SUCCESS });
      dispatch({ type: CLEAR_VALUES });
    } catch (error) {
      if (error.response.status === 401) return;
      dispatch({
        type: CREATE_LESSON_ERROR,
        payload: { msg: error.response.data.msg },
      });
    }
    clearAlert();
  };

  // useEffect(() => {
  const getLessons = async () => {
    // const { page, search, searchStatus, searchType, sort } = state;

    // // let url = `/lessen?page=${page}&status=${searchStatus}&LessonType=${searchType}&sort=${sort}`;
    // // if (search) {
    // //   url = url + `&search=${search}`;
    // //   console.log(url);
    // // }
    // let url = '/lessen';
    // dispatch({ type: GET_LESSONS_BEGIN });
    // try {
    //   const { data } = await authFetch(url);
    //   const { lessons } = data;
    //   // const { lessons, totalLessons, numOfPages } = data;

    //   // DynamicSort(dummylessons);
    //   DynamicSort(lessons);
    //   dispatch({
    //     type: GET_LESSONS_SUCCESS,
    //     payload: {
    //       lessons,
    //       // totalLessons,
    //       // numOfPages,
    //     },
    //   });
    // } catch (error) {
    //   logoutUser();
    // }
    // clearAlert();
    let url = baseServerUrl.concat('/lessen');
    dispatch({ type: GET_LESSONS_BEGIN });
    try {
      const response = await fetch(url);
      const lessons = await response.json();
      lessons.sort(DynamicSort('date'));
      console.log(lessons[0].age);
      dispatch({ type: GET_LESSONS_SUCCESS, payload: { lessons } });
    } catch (error) {
      logoutUser();
    }
  };

  //   getLessons();
  // }, []);

  const setEditLesson = (id) => {
    dispatch({ type: SET_EDIT_LESSON, payload: { id } });
  };

  const editLesson = async () => {
    dispatch({ type: EDIT_LESSON_BEGIN });

    try {
      const {
        day,
        date,
        duration,
        age,
        lessonLocationName,
        lessonLocationAddress,
        lessonType,
      } = state;
      await authFetch.patch(`/lessen/${state.editLessonId}`, {
        day,
        date,
        duration,
        age,
        lessonLocationName,
        lessonLocationAddress,
        lessonType,
      });
      dispatch({ type: EDIT_LESSON_SUCCESS });
      dispatch({ type: CLEAR_VALUES });
    } catch (error) {
      if (error.response.status === 401) return;
      dispatch({
        type: EDIT_LESSON_ERROR,
        payload: { msg: error.response.data.msg },
      });
    }
    clearAlert();
  };

  const deleteLesson = async (lessonId) => {
    dispatch({ type: DELETE_LESSON_BEGIN });
    try {
      await authFetch.delete(`/lessen/${lessonId}`);
      // getLessons();
    } catch (error) {
      if (error.response.status === 401) return;
      dispatch({
        type: DELETE_LESSON_ERROR,
        payload: { msg: error.response.data.msg },
      });
    }
    clearAlert();
  };

  const clearFilters = () => {
    dispatch({ type: CLEAR_FILTERS });
  };
  const changePage = (page) => {
    dispatch({ type: CHANGE_PAGE, payload: { page } });
  };

  const getCurrentUser = async () => {
    dispatch({ type: GET_CURRENT_USER_BEGIN });
    try {
      // const { data } = await authFetch('/auth/getCurrentUser');
      // const { user } = data;

      const { user } = dummyusers[0];

      dispatch({
        type: GET_CURRENT_USER_SUCCESS,
        payload: { user },
      });
    } catch (error) {
      if (error.response.status === 401) return;
      logoutUser();
    }
  };

  return (
    <GlobalContext.Provider
      value={{
        ...state,
        getActivities,
        displayAlert,
        getCurrentUser,
        setupUser,
        toggleSidebar,
        logoutUser,
        updateUser,
        handleChange,
        clearValues,
        createLesson,
        setEditLesson,
        deleteLesson,
        editLesson,
        getLessons,
        clearFilters,
        changePage,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
// make sure use
export const useGlobalContext = () => {
  return useContext(GlobalContext);
};

export { initialState };
